/*
 * Copyright (C) Regione Lombardia
 */
export interface AnagraficaLegge {
  id: number;
  descrizione: string;
  siglaLegge: string;
}

export class AnagraficaLegge implements AnagraficaLegge {
  id: number;
  descrizione: string;
  siglaLegge: string;
  constructor() {
    this.id = 0;
    this.descrizione = "";
    this.siglaLegge = "";
  }
}
